/**
 * Netlify Identity helpers for marketing-site Google OAuth.
 * Identity is hosted on the API site: {api}/.netlify/identity
 */

const API_URL = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');

export function getIdentityBaseUrl(): string {
  const fromEnv = (process.env.REACT_APP_IDENTITY_URL || '').trim().replace(/\/$/, '');
  if (fromEnv) return fromEnv;
  if (API_URL) return `${API_URL}/.netlify/identity`;
  return 'https://api.gastrobuddy.nl/.netlify/identity';
}

export function isIdentityConfigured(): boolean {
  return Boolean(getIdentityBaseUrl());
}

export type IdentityTokens = {
  access_token: string;
  refresh_token?: string;
  expires_in?: number;
};

/** Start Google OAuth via API-site Identity (full page navigation). */
export function startGoogleOAuth(redirectTo: string): void {
  const redirect = encodeURIComponent(redirectTo);
  const url = `${getIdentityBaseUrl()}/authorize?provider=google&redirect_to=${redirect}`;
  window.location.assign(url);
}

/**
 * Parse GoTrue hash tokens after OAuth redirect.
 * Hash looks like: #access_token=...&refresh_token=...&expires_in=...
 */
export function parseIdentityHashTokens(hash: string): IdentityTokens | null {
  const raw = hash.startsWith('#') ? hash.slice(1) : hash;
  if (!raw) return null;
  const params = new URLSearchParams(raw);
  const access_token = params.get('access_token');
  if (!access_token) return null;
  const refresh_token = params.get('refresh_token') || undefined;
  const expiresRaw = params.get('expires_in');
  const expires_in = expiresRaw ? Number(expiresRaw) : undefined;
  return { access_token, refresh_token, expires_in };
}

export function identityHashHasError(hash: string): boolean {
  const raw = hash.startsWith('#') ? hash.slice(1) : hash;
  if (!raw) return false;
  const params = new URLSearchParams(raw);
  return Boolean(params.get('error'));
}

/** Best-effort decode of JWT payload (no signature verify; server validates). */
export function peekJwtPayload(
  accessToken: string
): { email?: string; user_metadata?: { full_name?: string; name?: string } } | null {
  try {
    const parts = accessToken.split('.');
    if (parts.length < 2 || !parts[1]) return null;
    const json = atob(parts[1].replace(/-/g, '+').replace(/_/g, '/'));
    return JSON.parse(json) as {
      email?: string;
      user_metadata?: { full_name?: string; name?: string };
    };
  } catch {
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/utils/identity.ts